import { BreadcrumbsItemStyled, BreadcrumbsStyled } from './Breadcrumbs.styled';

export const Breadcrumbs = BreadcrumbsStyled;

Breadcrumbs.Item = BreadcrumbsItemStyled;
